/**
 * Parse pjsip.conf content and extract valid endpoint names.
 * Ignores: comments (;), [global], [system], [transport-*], [*_registration], [*_aor], [*_auth], [*_identify]
 */
export function parsePjsipEndpoints(pjsipConf: string): string[] {
  const endpoints: string[] = []

  // Match section headers that are NOT commented out (no ; before [)
  const sectionRegex = /^(?!\s*;)\s*\[([^\]]+)\]/gm
  let match

  while ((match = sectionRegex.exec(pjsipConf)) !== null) {
    const sectionName = match[1]

    // Skip sections that should be ignored
    if (
      sectionName === 'global' ||
      sectionName === 'system' ||
      sectionName.startsWith('transport-') ||
      sectionName.endsWith('_registration') ||
      sectionName.endsWith('_aor') ||
      sectionName.endsWith('_auth') ||
      sectionName.endsWith('_identify')
    ) {
      continue
    }

    endpoints.push(sectionName)
  }

  return endpoints
}

export const DEFAULT_PJSIP_CONF = `[global]
type=global
user_agent=Asterisk

[system]
type=system
timer_t1=500
timer_b=32000
threadpool_initial_size=10
threadpool_auto_increment=5
threadpool_idle_timeout=60
threadpool_max_size=0

[transport-udp]
type=transport
protocol=udp
bind=0.0.0.0:5061
tos=cs3
cos=3
external_media_address={ASTERISK_SERVER_IP}
external_signaling_address={ASTERISK_SERVER_IP}
allow_reload=no

[transport-tcp]
type=transport
protocol=tcp
bind=0.0.0.0:5062
tos=cs3
cos=3
external_media_address={ASTERISK_SERVER_IP}
external_signaling_address={ASTERISK_SERVER_IP}
allow_reload=no

; telnyx (call to phone number)
[telnyx1_auth]
type=auth
auth_type=userpass
username=flexxnn
password=HjdvTYBGUnT86tbmFjNNbdbmsmhuygyuglin7pmshg19

[telnyx1_aor]
type=aor
max_contacts=250
qualify_frequency = 60
contact=sip:flexxnn@sip.telnyx.com
contact=sip:sip.telnyx.com

[telnyx1]
type=endpoint
transport=transport-udp
disallow=all
;allow=ulaw
allow=alaw
;allow=g729
;allow=G722
rewrite_contact=yes
dtmf_mode=rfc4733
force_rport=yes
outbound_auth=telnyx1_auth
aors=telnyx1_aor

; telnyx (call by telnyx user by sip)
[telnyx2_aor]
type=aor
max_contacts=250
qualify_frequency = 60
contact=sip:sip.telnyx.com

[telnyx2_auth]
type=auth
auth_type=userpass
username=michaelpixel7
password=WiJvIECW

[telnyx2]
type=endpoint
transport=transport-udp
disallow=all
;allow=ulaw
allow=alaw
send_rpid=yes                        ; Equivalent to sendtrpid=yes
trust_id_inbound=yes                 ; Equivalent to trustrpid=yes
rtp_symmetric=yes                    ; Important for NAT handling
force_rport=yes                      ; Important for NAT handling
rewrite_contact=yes                  ; Important for NAT handling
outbound_auth=telnyx2_auth
aors=telnyx2_aor

; zpyqk9dh51v.sip.livekit.cloud (call to bot)
[livekit_aor]
type=aor
contact=sip:zpyqk9dh51v.sip.livekit.cloud
qualify_frequency=60          ; Check connection more frequently

[zpyqk9dh51v.sip.livekit.cloud]
type=endpoint
transport=transport-tcp
media_use_received_transport=yes
disallow=all
;allow=ulaw
allow=alaw
direct_media=no
dtmf_mode=rfc4733
send_rpid=yes                        ; Equivalent to sendtrpid=yes
trust_id_inbound=yes                 ; Equivalent to trustrpid=yes
rtp_symmetric=yes                    ; Important for NAT handling
force_rport=yes                      ; Important for NAT handling
rewrite_contact=yes                  ; Important for NAT handling
aors=livekit_aor


; ============================================
; TWILIO SIP TRUNK
; intone-engine-v1.pstn.twilio.com
; ============================================
[twilio_auth]
type=auth
auth_type=userpass
username=intone-dialer-trunk-dev
password=CzefXNRq9rd3tKz

[twilio_aor]
type=aor
contact=sip:intone-engine-v1.pstn.twilio.com
qualify_frequency=60

[twilio_identify]
type=identify
endpoint=twilio
match=intone-engine-v1.pstn.twilio.com

[intone-engine-v1.pstn.twilio.com]
type=endpoint
transport=transport-udp
disallow=all
allow=ulaw
allow=alaw
direct_media=no
dtmf_mode=rfc4733
rtp_symmetric=yes
force_rport=yes
rewrite_contact=yes
outbound_auth=twilio_auth
aors=twilio_aor

`
